import createLazyComponent from '../LazyComponent';

const LegalAgreements = createLazyComponent(() => import('./LegalAgreementsPage'));

export default LegalAgreements;
